/**
 * Component: Sticky Side CTA
 * 
 * Funcionalidad para el componente sticky CTA que abre un modal
 * con un enlace configurable.
 */

(function() {
  'use strict';

  /**
   * Cierra el CTA sticky
   * @param {string} uid - ID único del componente
   */
  window.closeStickyCta = function(uid) {
    const element = document.getElementById('sticky-cta--' + uid);
    if (element) {
      element.classList.add('hidden');
    }
  };

  /**
   * Inicializa un componente sticky CTA
   * @param {string} uid - ID único del componente
   */
  function initStickyCta(uid) {
    const banner = document.getElementById('sticky-cta--' + uid);
    const panel = document.getElementById('sticky-cta-panel--' + uid);
    const closeBtn = document.getElementById('sticky-cta-panel-close--' + uid);
    const overlay = document.getElementById('sticky-cta-overlay--' + uid);
    const bannerCloseBtn = banner ? banner.querySelector('.close-btn') : null;
    const targetLink = banner ? banner.getAttribute('data-target-link') : null;
    const isSelector = targetLink && targetLink.charAt(0) === '#';
    const externalModal = isSelector ? document.querySelector(targetLink) : null;
    // Verificar si tiene data-newsletter-open (para usar el sistema del newsletter-panel)
    const hasNewsletterOpen = banner ? banner.hasAttribute('data-newsletter-open') : false;

    if (!banner) return;

    // Si tiene data-newsletter-open, el newsletter-panel.js manejará el click
    // Solo necesitamos manejar el botón de cerrar del banner
    if (hasNewsletterOpen) {
      // El click en el banner será manejado por newsletter-panel.js
      // Solo prevenimos que el botón de cerrar interfiera
      if (bannerCloseBtn) {
        bannerCloseBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          // Cerrar el banner sticky, pero no el modal
          banner.classList.add('hidden');
        });
      }
      return; // No inicializamos el sistema propio si usa newsletter-panel
    }

    // Click en el banner abre el panel (pero no en el botón de cerrar)
    banner.addEventListener('click', function(e) {
      // Si el clic fue en el botón de cerrar, no abrir el panel
      if (e.target.closest('.close-btn')) {
        return;
      }

      // Si target_window_link es el ID de un div (ej: "#mi-modal"),
      // abrimos ese modal externo. En caso contrario, usamos el modal propio del snippet.
      if (externalModal) {
        externalModal.classList.add('open');
      } else if (panel) {
        panel.classList.add('open');
      }
      if (overlay) {
        overlay.classList.add('open');
      }
    });

    // Cerrar panel con el botón de cerrar del panel
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (externalModal) {
          externalModal.classList.remove('open');
        } else if (panel) {
          panel.classList.remove('open');
        }
        if (overlay) {
          overlay.classList.remove('open');
        }
      });
    }

    // Cerrar panel al hacer clic en el overlay
    if (overlay) {
      overlay.addEventListener('click', function() {
        if (externalModal) {
          externalModal.classList.remove('open');
        } else if (panel) {
          panel.classList.remove('open');
        }
        overlay.classList.remove('open');
      });
    }

    // Si hay un enlace en el panel, abrirlo en nueva ventana al hacer clic
    const panelLink = document.getElementById('sticky-cta-link--' + uid);
    if (panelLink && targetLink) {
      panelLink.addEventListener('click', function(e) {
        // El enlace ya tiene target="_blank", solo necesitamos asegurarnos
        // de que se cierre el panel después de un breve delay
        setTimeout(function() {
          if (panel) {
            panel.classList.remove('open');
          }
          if (overlay) {
            overlay.classList.remove('open');
          }
        }, 100);
      });
    }
  }

  /**
   * Inicializa el posicionamiento sticky del CTA
   * @param {string} uid - ID único del componente
   */
  function initStickyPositioning(uid) {
    const stickyCta = document.getElementById('sticky-cta--' + uid);
    if (!stickyCta) return;

    // Buscar elementos que puedan interferir (newsletter banner, etc.)
    const stopEl = document.querySelector('.blogposts--container') || 
                   document.getElementById('newsletter-banner') ||
                   document.querySelector('.newsletter-banner');

    const GAP = 16; // separación respecto a otros elementos
    const TOP_RATIO = 0.7; // 70% del viewport
    let ticking = false;

    function computeOffset() {
      // Centro ideal del botón en viewport
      const centerY = window.innerHeight * TOP_RATIO;

      // Altura actual del botón
      const rect = stickyCta.getBoundingClientRect();
      const halfH = rect.height / 2;

      // Bottom deseado del botón en viewport (siempre fijo)
      const desiredBottom = centerY + halfH;

      // Máximo bottom permitido: justo encima del elemento stop - GAP
      let offset = 0;
      if (stopEl) {
        const stopTop = stopEl.getBoundingClientRect().top;
        const maxBottom = stopTop - GAP;
        if (desiredBottom > maxBottom) {
          // Desplazamos hacia arriba lo necesario (negativo)
          offset = maxBottom - desiredBottom;
        }
      }

      // Redondeo para evitar subpíxeles que a veces "tiemblan"
      stickyCta.style.setProperty('--sticky-cta-offset', Math.round(offset) + 'px');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        computeOffset();
        ticking = false;
      });
    }

    // Reaccionar al scroll/resize de forma suave
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    // Por si cambian SVGs/fuentes/altura del bloque
    if (window.ResizeObserver) {
      new ResizeObserver(requestUpdate).observe(stickyCta);
    }

    // Colocación inicial
    requestUpdate();
  }

  /**
   * Inicializa todos los componentes sticky CTA en la página
   */
  function initAllStickyCtas() {
    // Buscar todos los elementos sticky-cta
    const stickyCtas = document.querySelectorAll('[id^="sticky-cta--"]');
    
    stickyCtas.forEach(function(banner) {
      const uid = banner.getAttribute('data-uid');
      if (uid) {
        initStickyCta(uid);
        initStickyPositioning(uid);
      }
    });
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStickyCtas);
  } else {
    initAllStickyCtas();
  }

  // Re-inicializar si se carga contenido dinámicamente (Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.detail.sectionId;
      const stickyCta = document.querySelector('[data-section-id="' + section + '"] [id^="sticky-cta--"]');
      if (stickyCta) {
        const uid = stickyCta.getAttribute('data-uid');
        if (uid) {
          initStickyCta(uid);
          initStickyPositioning(uid);
        }
      }
    });
  }
})();
